export const apiUrl = process.env.REACT_APP_SERVICE_BASE_URL;
